import Banner from "../../components/Banner/Banner";
import Services from "../home/services/Services";

const Service: React.FC = () => {



  return (
    <>
      {/* <Banner
        background={"/media/hero-bg.png"}
        title={"Our Services"}
        description={""}
      /> */}
       <Services/>
    </>
  );
};

export default Service;
